import SystemDiagnosticsPanel from "@/components/SystemDiagnosticsPanel";

/**
 * Temporary top-level route for the rpt_004 visibility investigation.
 *
 * Version 1.1 promoted System Diagnostics to a permanent Administration tab
 * (Administrator/Owner-only). This route stays open to any signed-in user
 * for the brief window we need Nathan (Office Staff) to capture his own
 * request context. Remove once the investigation is closed.
 */
export default function Diagnostics() {
  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="mb-4 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
        <strong>Temporary access.</strong> This route is open to non-admin
        users only to capture evidence for the current investigation. The
        permanent home for System Diagnostics is under
        <span className="mx-1 font-medium">Administration → System Diagnostics</span>
        (Administrator/Owner-only).
      </div>
      <SystemDiagnosticsPanel initialModule="delivery-profile" />
    </div>
  );
}
